export default {
    GET_CELEBRITIES: 'GET_CELEBRITIES'
};



// WEBPACK FOOTER //
// ./src/constants/CelebritiesConstants.js